// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading_bXhwH","title":"Heading_title_w9Q9S","subtitle":"Heading_subtitle_zRsvl"};